export default __webpack_public_path__ + "img/text-size.c6d4b5a6.svg";